module.exports = __webpack_public_path__ + "static/media/MobileDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.735ac405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquitetura_neg/MobileDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.png
// module id = 101
// module chunks = 0